
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5 4c-.548 0-1 .452-1 1v2a1 1 0 01-2 0V5c0-1.652 1.348-3 3-3h2a1 1 0 010 2H5zm11-1a1 1 0 011-1h2c1.652 0 3 1.348 3 3v2a1 1 0 11-2 0V5c0-.548-.452-1-1-1h-2a1 1 0 01-1-1zM3 16a1 1 0 011 1v2c0 .548.452 1 1 1h2a1 1 0 110 2H5c-1.652 0-3-1.348-3-3v-2a1 1 0 011-1zm18 0a1 1 0 011 1v2c0 1.652-1.348 3-3 3h-2a1 1 0 110-2h2c.548 0 1-.452 1-1v-2a1 1 0 011-1zM6 8a2 2 0 012-2h5a2 2 0 012 2v3a2 2 0 01-2 2H8a2 2 0 01-2-2V8zm7 0H8v3h5V8z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9 13a2 2 0 012-2h5a2 2 0 012 2v3a2 2 0 01-2 2h-5a2 2 0 01-2-2v-3zm7 0h-5v3h5v-3z","fill":"#fff"}})])
          )
        }
      }
    